import { render, staticRenderFns } from "./Grade.vue?vue&type=template&id=718617f7&scoped=true"
import script from "./Grade.vue?vue&type=script&lang=js"
export * from "./Grade.vue?vue&type=script&lang=js"
import style0 from "./Grade.vue?vue&type=style&index=0&id=718617f7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "718617f7",
  null
  
)

export default component.exports